var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarFold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10578_23482)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7784 9.76516C13.9689 9.76516 14.1256 9.90998 14.1445 10.0955L14.1464 10.1332L14.1463 13.2985C14.1463 13.3655 14.128 13.4312 14.0935 13.4885C13.9955 13.651 13.792 13.7106 13.6238 13.6326L13.5883 13.6137L10.9629 12.0311C10.9116 12.0002 10.8686 11.9572 10.8377 11.9059C10.7398 11.7434 10.7821 11.5356 10.9297 11.4233L10.9629 11.4007L13.5884 9.818C13.6457 9.78343 13.7114 9.76516 13.7784 9.76516ZM8.92559 11.0971C9.09642 11.0971 9.2349 11.2356 9.2349 11.4064V12.025C9.2349 12.1958 9.09642 12.3343 8.92559 12.3343H2.12083C1.95001 12.3343 1.81152 12.1958 1.81152 12.025V11.4064C1.81152 11.2356 1.95001 11.0971 2.12083 11.0971H8.92559ZM12.6373 6.76681C12.8081 6.76681 12.9466 6.90529 12.9466 7.07611V7.69473C12.9466 7.86555 12.8081 8.00404 12.6373 8.00404H2.12083C1.95001 8.00404 1.81152 7.86555 1.81152 7.69473V7.07611C1.81152 6.90529 1.95001 6.76681 2.12083 6.76681H12.6373ZM12.6373 2.43652C12.8081 2.43652 12.9466 2.57501 12.9466 2.74583V3.36445C12.9466 3.53527 12.8081 3.67375 12.6373 3.67375H2.12083C1.95001 3.67375 1.81152 3.53527 1.81152 3.36445V2.74583C1.81152 2.57501 1.95001 2.43652 2.12083 2.43652H12.6373Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10578_23482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarFold);
export default __webpack_public_path__ + "static/media/SidebarFold.50456b7d28069297474c663ade7b6e1c.svg";
export { ForwardRef as ReactComponent };